import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleMessageSelected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      fill="none"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <circle opacity={0.88} cx={28} cy={28} r={28} fill="#56A" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.48 14h20.07c1.37 0 2.48 1.1 2.45 2.48v13.4c0 1.37-1.1 2.47-2.48 2.47H22.5c-1.19 1.48-2.78 2.95-5.84 4.98A1.1 1.1 0 0115 36.07c.58-1.77.64-2.5.72-3.72h-3.24A2.47 2.47 0 0110 29.88v-13.4C10 15.1 11.1 14 12.48 14zM30 20.1a.5.5 0 00.5-.5V19a.5.5 0 00-.5-.5H15a.5.5 0 00-.5.5v.6c0 .28.22.5.5.5h15zm0 3.7a.5.5 0 00.5-.5v-.6a.5.5 0 00-.5-.5H15a.5.5 0 00-.5.5v.6c0 .28.22.5.5.5h15zM26.5 27a.5.5 0 01-.5.5H15a.5.5 0 01-.5-.5v-.6c0-.28.22-.5.5-.5h11c.28 0 .5.22.5.5v.6z"
        fill="#8F9DD6"
      />
      <path
        d="M23.45 21h20.07C44.9 21 46 22.1 46 23.48v13.4c0 1.36-1.1 2.47-2.48 2.47h-3.24c.08 1.21.14 1.95.72 3.72a1.1 1.1 0 01-1.66 1.26c-3.06-2.03-4.65-3.5-5.84-4.98H23.48A2.47 2.47 0 0121 36.88v-13.4A2.43 2.43 0 0123.45 21z"
        fill="#fff"
      />
      <path
        opacity={0.88}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.5 26.6a.5.5 0 01-.5.5H26a.5.5 0 01-.5-.5V26c0-.28.22-.5.5-.5h15c.28 0 .5.22.5.5v.6zm0 3.7a.5.5 0 01-.5.5H26a.5.5 0 01-.5-.5v-.6c0-.28.22-.5.5-.5h15c.28 0 .5.22.5.5v.6zM37 34.5a.5.5 0 00.5-.5v-.6a.5.5 0 00-.5-.5H26a.5.5 0 00-.5.5v.6c0 .28.22.5.5.5h11z"
        fill="#56A"
      />
    </svg>
  );
}

SvgPicCircleMessageSelected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleMessageSelected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleMessageSelected svgRef={ref} {...props} />
));
export default ForwardRef;
